(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["material-applications-tabs"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__crMaterialTabsScriptLoaded) {
    return;
  }

  window.__crMaterialTabsScriptLoaded = true;

  const rootSelector = '[data-cr-material-tabs-section]';
  const activeClass = 'is-active';

  const updateArrows = (panel) => {
    if (!panel) {
      return;
    }

    const scroller = panel.querySelector('[data-cr-scroller]');
    const arrows = panel.querySelectorAll('[data-cr-scroll]');

    if (!scroller || arrows.length === 0) {
      return;
    }

    const maxScroll = scroller.scrollWidth - scroller.clientWidth;
    const hasOverflow = maxScroll > 2;
    const atStart = scroller.scrollLeft <= 2;
    const atEnd = scroller.scrollLeft >= maxScroll - 2;

    arrows.forEach((arrow) => {
      const isNext = arrow.getAttribute('data-cr-scroll') === 'next';
      arrow.dataset.crHidden = hasOverflow ? 'false' : 'true';
      arrow.disabled = !hasOverflow || (isNext ? atEnd : atStart);
    });
  };

  const getCards = (panel) => Array.from(panel.querySelectorAll('[data-cr-card]'));

  const setActiveCard = (panel, card, options = {}) => {
    if (!panel || !card) {
      return null;
    }

    const cards = getCards(panel);
    const scroller = panel.querySelector('[data-cr-scroller]');

    cards.forEach((item) => {
      const isActive = item === card;
      item.classList.toggle(activeClass, isActive);
      const toggle = item.querySelector('[data-cr-card-toggle]');
      if (toggle) {
        toggle.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }
    });

    if (scroller && options.scroll !== false) {
      const targetLeft = Math.max(
        0,
        card.offsetLeft - Math.max((scroller.clientWidth - card.clientWidth) / 2, 0)
      );
      scroller.scrollTo({ left: targetLeft, behavior: options.instant ? 'auto' : 'smooth' });
    }

    return card;
  };

  const selectFirstCard = (panel, options = {}) => {
    if (!panel) {
      return null;
    }

    const firstCard = panel.querySelector('[data-cr-card]');
    if (firstCard) {
      setActiveCard(panel, firstCard, options);
    }

    return firstCard;
  };

  const activatePanel = (root, requestedPanelId, options = {}) => {
    const tabs = Array.from(root.querySelectorAll('[data-cr-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-cr-panel]'));
    const nextPanel = panels.find((panel) => panel.getAttribute('data-cr-panel') === requestedPanelId) || panels[0];

    if (!nextPanel) {
      return;
    }

    const panelId = nextPanel.getAttribute('data-cr-panel');

    tabs.forEach((tab) => {
      const isActive = tab.getAttribute('data-cr-tab') === panelId;
      tab.classList.toggle(activeClass, isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach((panel) => {
      const isActive = panel === nextPanel;
      panel.classList.toggle(activeClass, isActive);
      panel.hidden = !isActive;
    });

    const scroller = nextPanel.querySelector('[data-cr-scroller]');

    if (scroller && options.resetScroll !== false) {
      scroller.scrollTo({ left: 0, behavior: options.instant ? 'auto' : 'smooth' });
    }

    selectFirstCard(nextPanel, { instant: true, scroll: false });

    window.requestAnimationFrame(() => updateArrows(nextPanel));
  };

  const initializeRoot = (root) => {
    if (!root || root.dataset.crMaterialTabsInitialized === 'true') {
      return;
    }

    root.dataset.crMaterialTabsInitialized = 'true';

    const tabs = Array.from(root.querySelectorAll('[data-cr-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-cr-panel]'));

    if (tabs.length === 0 || panels.length === 0) {
      return;
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        activatePanel(root, tab.getAttribute('data-cr-tab'));
      });

      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') {
          return;
        }

        event.preventDefault();

        const currentIndex = tabs.indexOf(tab);
        const nextIndex = event.key === 'ArrowRight'
          ? (currentIndex + 1) % tabs.length
          : (currentIndex - 1 + tabs.length) % tabs.length;
        const nextTab = tabs[nextIndex];

        nextTab.focus();
        activatePanel(root, nextTab.getAttribute('data-cr-tab'));
      });
    });

    panels.forEach((panel) => {
      const scroller = panel.querySelector('[data-cr-scroller]');

      if (scroller) {
        scroller.addEventListener('scroll', () => updateArrows(panel), { passive: true });
      }

      panel.querySelectorAll('[data-cr-scroll]').forEach((arrow) => {
        arrow.addEventListener('click', () => {
          if (!scroller) {
            return;
          }

          const direction = arrow.getAttribute('data-cr-scroll') === 'next' ? 1 : -1;
          const distance = Math.max(scroller.clientWidth * 0.6, 240);
          scroller.scrollBy({ left: direction * distance, behavior: 'smooth' });
        });
      });

      getCards(panel).forEach((card) => {
        const toggle = card.querySelector('[data-cr-card-toggle]');

        if (!toggle) {
          return;
        }

        toggle.addEventListener('click', () => {
          setActiveCard(panel, card);
        });
      });

      updateArrows(panel);
    });

    const activePanel = panels.find((panel) => panel.classList.contains(activeClass)) || panels[0];
    activatePanel(root, activePanel.getAttribute('data-cr-panel'), { instant: true });
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll(rootSelector).forEach(initializeRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target || document);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target && event.target.closest ? event.target.closest(rootSelector) : null;
    const blockId = event.detail && event.detail.blockId;

    if (!root || !blockId) {
      return;
    }

    activatePanel(root, blockId, { instant: true });
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll(rootSelector).forEach((root) => {
      const activePanel = root.querySelector('[data-cr-panel].is-active') || root.querySelector('[data-cr-panel]');
      updateArrows(activePanel);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
